import SeriesSubPage from "./components/SeriesSubPage";
import { Skeleton } from "@/components/ui/skeleton";

/** View all cast while the series loads: the page's own shape, row for row. */
const SeriesCastSkeleton = () => (
  <SeriesSubPage.Skeleton testId="series-cast-skeleton" titleWidth="w-24">
    <ul className="grid gap-6 sm:grid-cols-2 sm:gap-x-10">
      {Array.from({ length: 4 }, (_, i) => (
        <li key={i} className="flex items-center gap-4">
          <Skeleton className="size-30 shrink-0 rounded-full" />
          <span className="flex flex-1 flex-col gap-1">
            <Skeleton className="h-5.5 w-1/2" />
            <Skeleton className="h-6 w-16" />
          </span>
        </li>
      ))}
    </ul>
  </SeriesSubPage.Skeleton>
);

export default SeriesCastSkeleton;
